const getIfBaseDomain = () => {
    const hostname = window.location.hostname || '';
    const match = hostname.match(/\.if\.(fi|se|no|dk)/);
    return match ? match[0] : hostname;
};

export const getCookie = (cname) => {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    const cookie = cookies.map((c) => c.trim()).find((c) => c.startsWith(name));
    return cookie ? cookie.substring(name.length, cookie.length) : '';
};

export const setCookie = (cname, cvalue) => {
    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000); // 1 day
    const expires = 'expires=' + d.toUTCString();
    const domain = 'domain=' + getIfBaseDomain();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;' + domain;
};

export const removeCookie = (cname) => {
    const d = new Date(1970, 1, 1);
    const expires = 'expires=' + d.toUTCString();
    const domain = 'domain=' + getIfBaseDomain();
    document.cookie = cname + '=;' + expires + ';path=/;' + domain;
};
